import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachLopApi } from "../../../api/ke-hoach/keHoachLopApi";
import { IKeHoachLopSaveRequest } from "../../../model/request/ke-hoach/IKeHoachLopSaveRequest";
import { IKeHoachLopSelectRequest } from "../../../model/request/ke-hoach/IKeHoachLopSelectRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eKeHoachLopActionIds, IKeHoachLopActionTypes } from "../../action-types/ke-hoach/IKeHoachLopActions";
import { rootActions } from "../../actions/rootActions";

export function* keHoachLopSaga(): any {
  yield takeEvery(eKeHoachLopActionIds.LOAD_START, loadWorker);
  yield takeEvery(eKeHoachLopActionIds.SAVE_START, saveWorker);
  yield takeEvery(eKeHoachLopActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(action: IKeHoachLopActionTypes): any {
  const res: IBaseRespone = yield call(keHoachLopApi.Select, action.payload as IKeHoachLopSelectRequest);
  if (res.is_success) {
    yield put(rootActions.keHoach.keHoachLop.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.keHoach.keHoachLop.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IKeHoachLopActionTypes): any {
  const res: IBaseRespone = yield call(keHoachLopApi.Save, action.payload as IKeHoachLopSaveRequest);
  if (res.is_success) {
    yield put(rootActions.keHoach.keHoachLop.SAVE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.keHoach.keHoachLop.SAVE_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* deleteWorker(action: IKeHoachLopActionTypes): any {
  const ids = action.payload as number[];
  const res: IBaseRespone = yield call(keHoachLopApi.Deletes, { ids });
  if (res.is_success) {
    yield put(rootActions.keHoach.keHoachLop.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.keHoach.keHoachLop.DELETE_ERRR(res.message ?? "Có lỗi")
    );
  }
}
